import { Chip, Icon, styled, TableCell, TableRow } from '@mui/material'
import React from 'react'

import CopyBox from '@/app/component/atom/copy-box'
import TableRowActions from '@/app/component/layout/table/actions'
import { APIKey } from '@/app/module/user/types'
import { formatDT } from '@/app/service/util/format'
import config from '@/config'

type Props = {
  apiKey: APIKey

  onDelete: (id: number) => void
  onEditClick: (apiKey: APIKey) => void
}

const dateTimeFormat = config.display.format.dateTime

const ApiKeyRow: React.FC<Props> = ({ apiKey, onDelete, onEditClick }) => {
  const handleDeleteClick = React.useCallback(() => onDelete(apiKey.id), [apiKey.id, onDelete])
  const handleEditClick = React.useCallback(() => onEditClick(apiKey), [apiKey, onEditClick])

  const id = `api-key-row-${apiKey.id}`

  return (
    <TableRow data-testid={id} id={id}>
      <TableCell data-testid={`${id}-name`}>{apiKey.name}</TableCell>
      <TableCell data-testid={`${id}-key`}>
        <APIKeyCopyBox hideInput inputVariant="standard" text={apiKey.key} title="" />
      </TableCell>
      <TableCell align="center" data-testid={`${id}-created`}>
        {formatDT(apiKey.created, undefined, dateTimeFormat)}
      </TableCell>
      <TableCell align="center" data-testid={`${id}-expires`}>
        {apiKey.expires ? formatDT(apiKey.expires, undefined, dateTimeFormat) : ''}
      </TableCell>
      <TableCell align="center" data-testid={`${id}-currently-valid`}>
        <Chip
          color={apiKey.currentlyValid ? 'success' : 'error'}
          label={apiKey.currentlyValid ? 'YES' : 'NO'}
          sx={{ color: (theme) => theme.palette.common.white }}
        />
      </TableCell>
      <TableCell align="center" data-testid={`${id}-active`}>
        <Icon color={apiKey.active ? 'success' : 'error'}>{apiKey.active ? 'check' : 'close'}</Icon>
      </TableCell>
      <TableCell align="center" data-testid={`${id}-actions`}>
        <ActionsContainer>
          <TableRowActions
            config={[
              {
                icon: 'settings',
                label: 'Manage token details',
                tooltip: 'Manage token details',
                onClick: handleEditClick,
              },
              {
                icon: 'delete',
                label: 'Delete token',
                tooltip: 'Delete token',
                onClick: handleDeleteClick,
              },
            ]}
          />
        </ActionsContainer>
      </TableCell>
    </TableRow>
  )
}

const APIKeyCopyBox = styled(CopyBox)(() => ({
  '& .MuiFormControl-root': {
    width: '100%',
  },
}))

const ActionsContainer = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  '& > div': {
    marginLeft: 0,
    marginRight: 0,
  },
})

export default ApiKeyRow
